import PricingDetail from './PricingDetail.styled';

export default PricingDetail;
